var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("©杭电助手 All Rights Reserved.")])}
var staticRenderFns = []

export { render, staticRenderFns }